import React from 'react';
import EditCategoryState from './editCategoryState/EditCategoryState';
import EditCategoryControlPanel from './components/EditCategoryControlPanel/EditCategoryControlPanel';
import Forms from './components/Forms/Forms';
import { ModalWindows } from './components/ModalWindows';
// import style from './index.module.scss';

const EditCategoryPage: React.FC = () => {
	return (
		<EditCategoryState>
			<EditCategoryControlPanel />
			<Forms />
			<ModalWindows />
		</EditCategoryState>
	);
};

export default EditCategoryPage;
